import {combineReducers, mergeReducers} from 'redux-merge-immutable-reducers';
import {handleActions} from 'redux-actions';
import {fromJS, Map} from 'immutable';

import actions from '../actions';
import reservation_request from './reservation/reservationRequest';
import params from './params';
import {currencies, main_currencies, current_currency} from '@synergycms_core/store/customer/currency';

//REDUCERS
const {
    langInfo: langActions,
    webType: webTypeActions,
    currencyCountry: currencyCountryActions,
    currentHotel: currentHotelActions,
    showAddresse: showAddresseActions,
    showNewsCheck: showNewsCheckActions,
    currentManagementGroup: currentManagementGroupActions,
    rawRequest: rawRequestActions,
    formCurrency: formCurrencyActions,
    trackingId: trackingIdActions,
} = actions.customer;

const lang_info = handleActions(
    {
        [langActions.get.toString()]: (langInfo, {payload}) => {
            return fromJS(payload);
        }
    },
    Map()
);

const web_type = handleActions(
    {
        [webTypeActions.get.toString()]: (webType, {payload}) => {
            return payload;
        }
    },
    String()
);

const customer = handleActions(
    {
        [currencyCountryActions.getAsync.toString()]: (customer, {payload}) => {
            return customer
                .set('client_ip', payload.ClientIP)
                .set('country', Map({code: payload.CountryCode}))
                .set('currency', Map({code: payload.CurrencyCode}));
        }
    },
    Map()
);

const current_management_group = handleActions(
    {
        [currentManagementGroupActions.get.toString()]: (
            managementGroup,
            {payload}
        ) => {
            return fromJS(payload);
        }
    },
    null
);

const current_hotel = handleActions(
    {
        [currentHotelActions.get.toString()]: (
            hotel,
            {payload}
        ) => {
            return fromJS(payload);
        }
    },
    null
);

const show_addresse = handleActions(
    {
        [showAddresseActions.get.toString()]: (
            showAddresse,
            {payload}
        ) => {
            return payload;
        }
    },
    null
);

const show_news_check = handleActions(
    {
        [showNewsCheckActions.get.toString()]: (
            showNewsCheck,
            {payload}
        ) => {
            return payload;
        }
    },
    null
);

const raw_request = handleActions(
    {
        [rawRequestActions.get.toString()]: (
            rawRequest,
            {payload}
        ) => {
            return fromJS(payload);
        }
    },
    Map()
);

const form_currency = handleActions(
    {
        [formCurrencyActions.get.toString()]: (
            formCurrency,
            {payload}
        ) => {
            return payload;
        }
    },
    Map()
);

const tracking_id = handleActions(
    {
        [trackingIdActions.get.toString()]: (
            trackingId,
            {payload}
        ) => {
            return payload;
        }
    },
    Map()
);


export default mergeReducers(
    customer,
    combineReducers({
        params,
        reservation_request,
        lang_info,
        web_type,
        currencies,
        main_currencies,
        current_currency,
        current_hotel,
        show_addresse,
        show_news_check,
        current_management_group,
        raw_request,
        form_currency,
        tracking_id,
    })
);
